import DiscardModal from './DiscardModal'
export default DiscardModal
